(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/get-modal-root.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/get-modal-root.js');
"use strict";


const {
  unmountComponentAtNode
} = ReactDOM;
const ROOT_DOM_ID = 'flyingbetslip-react';

const getModalRoot = inputBag => {
  const {
    unmount
  } = inputBag || {};
  const oldContainer = document.getElementById(ROOT_DOM_ID);
  if (oldContainer) {
    if (unmount) {
      unmountComponentAtNode(oldContainer);
    }
    return oldContainer;
  }
  const newContainer = document.createElement('DIV');
  newContainer.setAttribute('id', ROOT_DOM_ID);
  document.body.appendChild(newContainer);
  return newContainer;
};
setGlobal('svs.components.sport.quickplayModal.getModalRoot', getModalRoot);

 })(window);